import React, { Component } from "react"
import OutsideClickTrigger from "../common/OutsideClickTrigger"

class ParkingExtraServicesDetailsModal extends Component {
  render() {
    const { extraProduct, extraProductOffer, contentVariant } = this.props
    if (!this.props.isActive || !extraProductOffer) return ""
    return (
      <div className="overlay overlay--modal overlay--fixed is-active">
        <div className="modal modal--parking-product-row-modal modal-rows-padded">
          <OutsideClickTrigger onOutsideClick={() => this.props.extraServicesDetailsModalToggle()}>
            <React.Fragment>
              <button className="button button--icon js--close-modal" onClick={() => this.props.extraServicesDetailsModalToggle()}>
                <span className="icon">
                  <svg className="svg-icon svg-icon--close-new">
                    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-close-new">
                      &nbsp;
                    </use>
                  </svg>
                </span>
              </button>
              <div className="modal__content modal__content--no-padding">
                <div className="modal__content__inner">
                  <div className="modal__top">
                    <header>
                      <div className="modal__headline">
                        <h3 className="headline-md">{extraProductOffer.name}</h3>
                      </div>
                      <div className="rich-text">
                        <p>
                          <span dangerouslySetInnerHTML={{ __html: contentVariant && contentVariant.variantDescription }}></span>
                        </p>
                      </div>
                    </header>
                  </div>
                  <div className="modal__middle">
                    {contentVariant && contentVariant.usp && contentVariant.usp.bullets ? (
                      <div className="parking-product-highlight__usp">
                        <ul>
                          {contentVariant.usp.bullets.map((u, index) => (
                            <li key={index}>
                              <svg className="svg-icon svg-icon--checkmark">
                                <use xlinkHref="/dist/svg/symbols.svg#svg-checkmark"></use>
                              </svg>
                              {u}
                            </li>
                          ))}
                        </ul>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </React.Fragment>
          </OutsideClickTrigger>
        </div>
      </div>
    )
  }
}
export default ParkingExtraServicesDetailsModal
